import { render } from "./BusinessSectors.vue?vue&type=template&id=adfc20f6"
import script from "./BusinessSectors.vue?vue&type=script&lang=js"
export * from "./BusinessSectors.vue?vue&type=script&lang=js"

import "./BusinessSectors.vue?vue&type=style&index=0&id=adfc20f6&lang=scss"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__